export var ENGLISH = 'en-US';
export var SPANISH = 'es-US';
export var FRENCH = 'fr-CA';
var languages = {
    ENGLISH: ENGLISH,
    SPANISH: SPANISH,
    FRENCH: FRENCH
};
export default languages;
